const messageBasicSettings = {
    toast: true,
    showConfirmButton: false,
    position: 'top-end',
    timer: 6000
};

export const successMessage = {
    icon: 'success',
    ... messageBasicSettings
};

export const errorMessage = {
    icon: 'error',
    ... messageBasicSettings
};

export const messageTexts = {
    employeeDownloadPdf: 'Le fichier de demande de dispense a été téléchargé sur votre ordinateur. Veuillez l’imprimer et signer. Vous pouvez toujours procéder à la signature électronique si vous le souhaitez',
    resendEmailSuccess: 'L’email de relance a bien été envoyé',
    resendEmailError: 'L’email de relance n’a pas pu être envoyé, veuillez nous contacter si le problème persiste',
    abortSuccess: 'La demande de dispense a bien été annulée et archivée. Vous pouvez la consulter sur la page Recherche des dispenses',
    rejectSuccess: 'La demande de dispense a bien été refusée et archivée. Vous pouvez la consulter sur la page Recherche des dispenses',
    dueDraftSave: 'Votre projet de DUE a bien été sauvegardé. Lorsque vous reviendrez vous pourrez reprendre à partir de cette étape',
    notAllBeneficiariesCovered: 'L’établissement d’une DUE pour Cadres et Non Cadres impose de faire obligatoirement deux versions. Veuillez créer une DUE pour la 2° catégorie de bénéficiaires',
    settingsChangeSuccess: 'Le paramétrage a bien été enregistré',
    manualMotifsChangeSuccess: 'Les cas de dispenses facultatifs sont désormais disponibles dans le module "Dispense d’affiliation" pour vos salariés.',
    passwordSuccessfullyChanged: 'Votre mot de passe a été mis à jour',
    sendDueSuccess: 'L’email a bien été envoyé.',
    resendDueSuccess: 'L’email avec le lien vers la page de signature de la DUE a été renvoyé.',
    resendDueError: 'Une erreur s’est produite, l’email n’a pas été envoyé. Modifiez la DUE, allez jusqu’à l’étape 7 et vérifiez l’adresse email du signataire.',
    nonFinalizedExemption : 'Cette personne xxxx@xxxx.xx a déjà une demande de dispense d’affiliation, la demande est non-validée.',
    createEnterpriseSuccess: 'L’entreprise a bien été créée.',
    updateEnterpriseSuccess: 'La modification a bien été enregistrée.',
    createOrUpdateEnterpriseError: 'Une erreur s’est produite, veuillez réessayer ou contactez l’administrateur.',
    sendEmployeeSendEmailsSuccess: 'Les notifications ont été envoyées. Les statuts seront affichés sur cette page dans la section "Suivi des notifications".',
    uploadDueSignOffSheetDocumentSuccess: 'La feuille d’émargement est téléversée avec succès.',
    createAmendmentDueSuccess: 'L’avenant à la DUE a été créé avec succès.',
    exportListRequestSubmitted: 'La demande a bien été prise en compte.<br />Lorsque l’export demandé sera prêt, vous pourrez le télécharger sur cette page.',
    exportListDeletionSubmitted: 'La demande de suppression a bien été prise en compte.',
};
